<template>
  <div class="fullpage">
    <div  v-if="type == 0">
      <div style="margin-bottom: 10px;">
        <span> <span style="color: red;">*</span> 索赔车型：</span>
        <el-select v-model="value" placeholder="请选择">
    <el-option
      v-for="item in cartypelist"
      :key="item.id"
      :label="item.seriesModel"
      :value="item.id">
    </el-option>
  </el-select>
      </div>
      <div>
        <span> <span style="color: red;">*</span> 索赔车辆：<span>{{ aclist.length }} <span>明细</span> </span> </span> 
        <el-button type="primary" plain @click="openDaoRuDialog">点击上传</el-button>
      </div>
      <!-- <el-input style="width: 30%;margin-right: 10px;" v-model="frameNum" :placeholder="`${$t('menu.FrameNumber')}/${$t('menu.EngineNumber')}`"></el-input> 
      <el-button plain @click="querySearch">{{ $t('menu.search') }}</el-button> -->
    </div>
  
    <div class="compensateInfo">
      <div class="title">
        <div class="name">{{ $t('menu.ClaimInformation') }}</div>
      </div>
      <div v-if="showInfo" class="beforeShowInfo">
        {{showinfoMsg}}
      </div>
      <div v-else>
        <div class="infoItemOne">
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.ClaimType') }}
            </div>
            <div class="inputBox">
              <el-select v-model="carInfo.co.claimType" :placeholder="`${$t('menu.ClaimType')}`" clearable v-if="type == 0 || type == 1">
                <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,index) in titleList" :key="index"></el-option>
              </el-select>
              <div v-if="type == 2 ">
                {{(carInfo.co.claimType!='' && carInfo.co.claimType!=null) ? ( iszh == 'zh' ? titleList.filter(e=>e.dictValue == carInfo.co.claimType)[0].dictLabel : titleList.filter(e=>e.dictValue == carInfo.co.claimType)[0].dictLabelEn) : ''}}
              </div>
            </div>
          </div>
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Failurecategory') }}
            </div>
            <div class="inputBox">
              <el-select v-model="carInfo.co.faultType" :placeholder="`${$t('menu.Failurecategory')}`" filterable clearable v-if="type == 0 || type == 1">
                <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,index) in titleLista" :key="index"></el-option>
              </el-select>
              <div v-if="type == 2 ">
                {{(carInfo.co.faultType!='' && carInfo.co.faultType!=null) ? ( iszh == 'zh' ? titleLista.filter(e=>e.dictValue == carInfo.co.faultType)[0].dictLabel : titleLista.filter(e=>e.dictValue == carInfo.co.faultType)[0].dictLabelEn) : ''}}
              </div>
            </div>
          </div>
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Mileage')}}(km)</div>
            <div class="inputBox">
              <el-input v-model="carInfo.co.mileage" :placeholder="$t('menu.Enter')" v-if="type == 0 || type == 1"></el-input>
              <div v-if="type == 2">{{carInfo.co.mileage}}</div>
            </div>
          </div>
          <div class="infoItemOneItem" v-if="type == 2">
            <div class="name">{{ $t('menu.ClaimAmount') }}</div>
            <div class="inputBox" style="color: red;">{{  carInfo.co.claimAmount }}</div>
          </div>
          <div class="infoItemOneItem" v-if="type == 0 || type == 1">
            <div class="name"><span style="color: red;">*</span> {{$t('menu.Applicationtime')}}</div>
            <div class="inputBox">
              <el-date-picker v-model="carInfo.co.applicationTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('menu.Expected')"></el-date-picker>
            </div>
          </div>
          <div class="infoItemOneItem" v-if="type == 2">
            <div class="name">{{ $t('menu.ApplicationTime') }}</div>
            <div class="inputBox">{{carInfo.co.applicationTime}}</div>
          </div>
          <div class="infoItemOneItem" v-if="type == 0 || type == 1">
            <div class="name"><span style="color: red;">*</span> {{$t('menu.Country1')}}</div>
            <div class="inputBox">
              <el-select v-model="carInfo.co.applyingDealerAreaId" :placeholder="`${$t('menu.Country')}`" filterable clearable v-if="type == 0 || type == 1">
                <el-option v-for="item in gb" :key="item.dictValue" :label="bbca(item.dictLabel)" :value="item.dictValue"></el-option>
              </el-select>
            </div>
          </div>
          <div class="infoItemOneItem" v-if="type == 2">
            <div class="name">{{$t('menu.Country1')}}</div>
            <div class="inputBox">
              <!-- {{aeera.filter(e=>e.dictValue == carInfo.co.applyingDealerAreaId).length>0? (iszh ? aeera.filter(e=>e.dictValue == carInfo.co.applyingDealerAreaId)[0].dictLabel : aeera.filter(e=>e.dictValue == carInfo.co.applyingDealerAreaId)[0].dictLabelEn) : carInfo.co.applyingDealerAreaId}}
            </div> -->
            {{ bbcaa( carInfo.co.applyingDealerAreaId) }}
            </div>
          </div>
        </div>
        <div class="infoItemTwo">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{
            $t('menu.ProblemDescription')
          }}</div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.faultDescription"
            v-if="type == 0 || type == 1" ></el-input>
          <div v-if="type == 2">{{carInfo.co.faultDescription}}</div>
        </div>
        <div class="infoItemTwo">
          <!-- <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Analysis') }}
          </div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.causeAnalysis"
            v-if="type == 0 || type == 1"></el-input>
          <div v-if="type != 0 && type != 1">{{carInfo.co.causeAnalysis}}</div> -->
        </div>
        <div class="infoItemTwo">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Solution') }}
          </div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.repairPlan"
            v-if="type == 0 || type == 1"></el-input>
          <div v-if="type != 0 && type != 1">{{carInfo.co.repairPlan}}</div>
        </div>
      </div>
    </div>
    <div class="compensateDetail" v-if="!showInfo">
      <div class="title">
        <div class="nameList">
          <div class="nameItem" :class="active == 1 ? 'acti' : ''" @click="changeActive(1)">{{ $t('menu.ClaimDetails')}}</div>
          <!-- <div class="nameItem" :class="active == 2 ? 'acti' : ''" @click="changeActive(2)">{{ $t('menu.Attachment') }}</div> -->
          <!-- <div class="nameItem" :class="active == 3 ? 'acti' : ''" @click="changeActive(3)" v-if="type != 0">{{ $t('menu.ClaimRecord') }}</div>
          <div class="nameItem" :class="active == 4 ? 'acti' : ''" @click="changeActive(4)" v-if="type != 0">{{ $t('menu.OperationRecord') }}</div> -->
        </div>
      </div>
      <!-- 明细 -->
      <div class="detail" v-if="active == 1">
        <div class="typeTitle">
          <div class="name"><span style="color: red;">*</span>  {{$t('menu.Claimedpart')}}</div>
        </div>
        <el-button plain @click="addParts" v-if="type == 0 || type == 1" style="margin-bottom: 10px;">{{ $t('menu.AddTo') }}</el-button>
        <el-table  empty-text=" " :data="carInfo.coParts" border style="width: 100%">
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="120"></el-table-column>
          <el-table-column prop="partName" :label="$t('menu.PartName')" min-width="120">
            <template slot-scope="scope">{{ iszh=='zh' ? scope.row.partName : scope.row.partNameEn }}</template>
          </el-table-column>
          <el-table-column :label="$t('menu.Currency')" min-width="80">
            <template slot-scope="scope">{{ currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('menu.UnitPrice')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">{{ currency == 'CNY' ? scope.row.purchasePriceCny : currency == 'EUR' ? scope.row.purchasePriceEur : scope.row.purchasePriceUsd }}</template>
          </el-table-column>
          <el-table-column prop="unitPrice" :label="$t('menu.UnitPrice')" min-width="120" v-if="type == 2"></el-table-column>
          <el-table-column :label="$t('menu.Quantity')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <el-input v-model="scope.row.minPurchaseQuantity" @input="sumMoney"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" :label="$t('menu.Quantity')" min-width="80" v-if="type == 2"></el-table-column>
          <el-table-column :label="$t('menu.Amount')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              {{Number(currency == 'CNY' ? scope.row.purchasePriceCny : currency == 'EUR' ? scope.row.purchasePriceEur : scope.row.purchasePriceUsd) * Number(scope.row.minPurchaseQuantity) | NumFormat}}
            </template>
          </el-table-column>
          <el-table-column prop="amount" :label="$t('menu.Quantitya')" min-width="80" v-if="type == 2"></el-table-column>
          <el-table-column :label="$t('menu.Operation')" width="150" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deleteCoparts(scope.$index, scope.row)">{{ $t('menu.Delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 10px 0;" v-if="type == 0 || type == 1">{{ $t('menu.Amount') }}： <span style="color: red;">{{amount |NumFormat}}</span></div>
        <div style="padding: 10px 0;" v-if="type == 2">{{ $t('menu.Amount') }}： <span style="color: red;">{{carInfo.coPartAmount |NumFormat}}</span></div>
        <!-- <div class="typeTitle">{{ $t('menu.ClaimForLaborHour') }}</div>
        <el-table :data="coLabours" border style="width: 80%">
          <el-table-column prop="labourName" label="名称" min-width="80"></el-table-column>
          <el-table-column prop="name" :label="$t('menu.Currency')" min-width="80"></el-table-column>
          <el-table-column prop="unitPrice" :label="$t('menu.StandardLaborCost')" min-width="80"></el-table-column>
          <el-table-column prop="labourHours" :label="$t('menu.LaborHours')" min-width="80"></el-table-column>
          <el-table-column prop="labourCost" :label="$t('menu.LaborCost')" min-width="80"></el-table-column>
          <el-table-column prop="needClaim" :label="$t('menu.SupportClaims')" min-width="80"></el-table-column>
        </el-table>
        <div style="padding: 10px 0;">{{ $t('menu.SubTotal') }}： <span style="color: red;">$ 200.00</span></div>
        <div class="typeTitle">
          <div class="name" v-if="type == 0 || type == 1">其他费用</div>
          <div class="name" v-if="type != 0 && type != 1">自定义</div>
          <el-button plain v-if="type == 0 || type == 1">{{ $t('menu.AddTo') }}</el-button>
        </div>
        <el-table :data="tableData" border style="width: 60%">
          <el-table-column prop="name" label="" min-width="80" v-if="type == 0 || type == 1"></el-table-column>
          <el-table-column prop="name" label="名称" min-width="120"></el-table-column>
          <el-table-column prop="name" :label="$t('menu.Currency')" min-width="80"></el-table-column>
          <el-table-column prop="name" label="费用" min-width="80"></el-table-column>
          <el-table-column prop="name" :label="$t('menu.SupportClaims')" min-width="80"></el-table-column>
        </el-table>
        <div style="padding: 10px 0;">{{ $t('menu.SubTotal') }}： <span style="color: red;">$ 200.00</span></div> -->

        <!-- 附件 -->
        <!-- <div class="detail" v-if="active == 2"> -->
        <div class="typeTitle">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{$t('menu.Attachment')}}</div>
        </div>
        <el-upload action="#" :on-remove="handleRemove" :on-preview="handlePictureCardPreview" :http-request="uploadFile" :before-upload="beforeAvatarUpload" 
          :file-list="fileList" v-if="type == 0 || type == 1">
          <el-button size="small" type="primary">{{$t('menu.Uploadfiles')}}</el-button>
          <div slot="tip" class="el-upload__tip">{{$t('menu.Note10M')}}</div>
        </el-upload>
        <div  v-if="type == 2">
          <a v-for="(item,index) in JSON.parse(carInfo.co.imageData)" :key="index" :href="item.url" style="text-decoration:auto;color: #000;">{{ item.name }}</a>
        </div>
      </div>
      <!-- 索赔记录 -->
      <div class="detail" v-if="active == 3">
        <el-table  empty-text=" " :data="carInfo.hisCos" border style="width: 100%">
          <el-table-column prop="claimNumber" :label="$t('menu.ClaimNumber')" min-width="80"></el-table-column>
          <el-table-column :label="$t('menu.Vehicle')" min-width="80">
            <template slot-scope="scope">{{ iszh == 'zh' ? scope.row.motorName : scope.row.motorNameEn}}</template>
          </el-table-column>
          <el-table-column prop="claimType" :label="$t('menu.ClaimType')" min-width="80">
            <template slot-scope="scope">
              {{iszh == 'zh' ? titleList.filter(e=>e.dictValue ==scope.row.claimType)[0].dictLabel : titleList.filter(e=>e.dictValue == scope.row.claimType)[0].dictLabelEn}}
            </template>
          </el-table-column>
          <el-table-column prop="mileage" :label="$t('menu.Mileage')" min-width="80"></el-table-column>
          <el-table-column prop="currencyType" :label="$t('menu.Currency')" min-width="80"></el-table-column>
          <el-table-column prop="claimAmount" :label="$t('menu.ClaimAmount')" min-width="80"></el-table-column>
          <el-table-column prop="applicationTime" :label="$t('menu.ApplicationTime')" min-width="80"></el-table-column>
        </el-table>
      </div>
      <!-- 操作记录 -->
      <div class="detail" v-if="active == 4">
        <el-table  empty-text=" " :data="carInfo.coOperationLogs" border style="width: 100%">
          <el-table-column prop="actionTime" :label="$t('menu.Timecaozuo')" min-width="80"></el-table-column>
          <el-table-column prop="actionUserName" :label="$t('menu.Operator')" min-width="80"></el-table-column>
          <el-table-column prop="actionEvent" :label="$t('menu.OperationContent')" min-width="80"></el-table-column>
          <el-table-column prop="remarks" :label="$t('menu.Remarks')" min-width="80"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="subBox" v-if="!showInfo">
      <!-- <div class="totalMoney">合计： <span style="color: red;">$ 20.23</span></div> -->
      <div class="butto">
        <el-button type="primary" @click="submit" v-if="type == 0">{{$t('menu.Submitsuopei')}}</el-button>
        <el-button type="primary" @click="updateMyCo" v-if="type == 1"> {{ $t('menu.Save') }} </el-button>
        <el-button plain @click="modify" v-if="type == 2 && carInfo.co.status == 10">{{ $t('menu.Modify') }}</el-button>
        <el-button plain @click="cancelMyCo" v-if="type == 2 && carInfo.co.status == 10">{{$t('menu.Cancelsuopei') }}</el-button>
        <el-button type="primary" v-if="type == 2 && carInfo.co.status == 60" @click="modify">重新提交</el-button>
        <el-button  v-if="type == 0 || type == 1" @click="cancel"> {{ $t('menu.Cancel') }} </el-button>
      </div>
    </div>

    <!--添加配件  -->
    <el-dialog :title="$t('menu.AddParts')" :visible.sync="dialogVisiblePart" width="800px" :close-on-click-modal="false" @close="ccac">
      <div class="partBox">
        <div class="searchBox">
          <el-input v-model="searchKey" :placeholder=" $t('menu.Enter') "></el-input>
          <el-button plain @click="pageQueryPartList">{{ $t('menu.search') }}</el-button>
        </div>
        <el-table :data="partList" border style="width: 100%" @selection-change="handleSelectionChange" height="500">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="80"></el-table-column>
          <el-table-column :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('menu.Partcategory')" min-width="80">
            <template slot-scope="scope">
              {{ sxtitle(scope.row.partCategory)  }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('menu.Currency')" min-width="80">
            <template slot-scope="scope">{{ currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('menu.UnitPrice')" min-width="80">
            <template slot-scope="scope">{{ currency == 'CNY' ? scope.row.purchasePriceCny : currency == 'EUR' ? scope.row.purchasePriceEur : scope.row.purchasePriceUsd }}</template>
          </el-table-column>
        </el-table>
        <div class="buttBox">
          <el-button type="primary" @click="getpartList">{{$t('menu.Confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 文件预览 -->
    <el-dialog :visible.sync="filedialogVisible" width="70%">
      <iframe :src="filedialogImageUrl" frameborder="0" style="width: 100%;height: 100%;"></iframe>
    </el-dialog>
    <!-- 提交成功弹窗 -->
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center>
      <div class="img"><img src="../../assets/images/ck_tg.png" alt=""></div>
      <div style="width: 100%;text-align: center;margin: 30px 0">{{$t('menu.Success')}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="continueToApply">{{$t('menu.Continue')}}</el-button>
        <el-button type="primary" @click="viewOrders">{{$t('menu.Viewtheorder')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('menu.Import')" :visible.sync="daoruFlag" width="40%">
      <div class="daoru-big" style="padding: 20px;">
        <div class="daoru-box" style="display: flex;margin-bottom: 5%;">
          <div >{{ $t('menu.PartsImportTemplate') }}</div>
          <div style="margin-left: 10%;color: #409eff;cursor: pointer;" class="daoru-download" @click="downMoBan">{{ $t('menu.Download') }}</div>
        </div>
        <div style="width:40%;margin: 0 auto;border: 1px #409eff solid;padding: 10px;text-align: center;border-radius: 5px;color: #409eff;cursor: pointer;">
          <el-upload  action="" :http-request="httpRequest" :show-file-list="false" :file-list="fileListaa">
          <div  size="small" type="primary">{{ $t('menu.SelectFile') }}</div>
        </el-upload>
        </div>

        <!-- <div class="daoru-btn">{{ $t('menu.Import') }}</div> -->
      </div>

      <!-- <div>检测到：78个配件</div> -->

      <div style="display: flex; justify-content: space-evenly;">
        <!-- <div class="daoru-confirm">确定</div> -->
        <!-- <div class="daoru-confirm cconfirm">确定注册</div> -->
        <!-- <div class="daoru-confirm cconfirm">确定</div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageQueryPartList,importFilea, pageQueryVin, cancelMyCo, upload, pageQuerySa,querytype,gbquerytype,submitCoDto,mcVehicleOfDealerLista,pageQueryParta,listMcSeriesModels,getMyCoDto,updateMyCo } from '../../api/api'
export default {
  data () {
    return {
      type: 0, //类型（0-新增，1-修改，2-详情(审核中、已取消、待接收)  3-重新提交）
      iszh:sessionStorage.getItem('i18n'),
      titleList:[],
      cartypelist:[],
      active: 1,
      value:'',
      dialogVisiblePart: false,
      centerDialogVisible: false,
      currency:sessionStorage.getItem('shbz'), //币种
      showInfo:true,
      showinfoMsg:this.$t('menu.Pleaseentertheframe'),
      searchKey: '',
      amount:0,
      frameNum: '', //发动机号
      carList: [],
      carInfo: {
        co:{
          claimType: '', //索赔类型
          mileage: '', //行驶里程
          applicationTime: '', //经销商申请时间
          faultDescription: '', //故障描述
          causeAnalysis:'', //原因分析
          repairPlan: '', //解决方案
        },
        coParts: [],//索赔配件
      },
      coLabours: [
        {
          labourName: '',//名称
          //币种
          unitPrice: '',//标准工时费
          labourHours: '',//工时
          labourCost: '',//工时费
          needClaim: '',//支持索赔
        }
      ],//索赔工时
      partList: [],//配件列表
      fileListaa:[],
      aclist:[],
      filedialogImageUrl: '',//文件预览地址
      titleLista:[],
      filedialogVisible: false,
      fileList: [],//上传文件列表
      selectpart:[],
      daoruFlag:false,
      gb:[],
      aeera: [],
      staue: [
      {
          name: this.$t('menu.All'),
          num: 0,
          id: ''
        },
        {
          name: this.$t('menu.Unread'),
          num: 0,
          id: 10
        },
      
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '20'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '29'
        },
        {
          name:this.$t('menu.Underreview'),
          num: 0,
          id: '30'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '39'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '40'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '49'
        },
        {
          name: this.$t('menu.Approved'),
          num: 0,
          id: '50'
        },
          {
          name: this.$t('menu.ypfl'),
          num: 0,
          id: '55'
        },
        {
          name: this.$t('menu.Rejected2'),
          num: 0,
          id: '59'
        },
        {
          name: this.$t('menu.Cancelled'),
          num: 0,
          id: '60'
        },
      ],
      jxc:[],
      inle:'zh'
    }
  },
  filters:{
    NumFormat(value) {
      if (!value) return '0.00';
      // 将数值截取，保留两位小数
      value = Number(value).toFixed(2);
      // 获取整数部分
      const intPart = Math.trunc(value);
      // 整数部分处理，增加,
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      let floatPart = '.00';
      // 将数值截取为小数部分和整数部分
      const valueArray = Number(value)
          .toString()
          .split('.');
      if (valueArray.length === 2) {
          // 有小数部分
          floatPart = valueArray[1].toString(); // 取得小数部分
          return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    }

  },
  mounted () {
    this.getQuerytype()
    this.aeer()
    this.gbquerytype()
    this.gbquerytypea()
    this.listMcSeriesModel()
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    if(this.$route.query.type) {
      this.type= this.$route.query.type
      if(this.type == 2){
        this.showInfo = false
        this.getMyCoDto(this.$route.query.id)
      }
    }
  },
  watch:{
    fileList(newV,oldV){
      if(JSON.stringify(newV) != this.carInfo.co.imageData){
        let v =[]
        this.fileList.forEach((e,i)=>{
          let  bbb ={
            name:e.name,
            url:e.url,
            deleted:false
          }
         v.push(bbb)
        })
        this.carInfo.co.imageData = JSON.stringify(v)
      }
    },
    '$route': {
      handler (newVal, old) {
        console.log(old,88888888);
        if(old === undefined){
        } else {
          location.reload()
        }
        
      },
      immediate: true
    }
  },
  methods: {
      sxtitle(e){
      let a =''
        // console.log(11,JSON.parse(e.categoryNameEn));
        
      if(this.inle=='zh'){
        a=e.categoryName
      }
    if(this.inle=='en'){
      if(e.categoryNameEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.categoryNameEn)
     
        a=c.en
      }else{
        a=e.categoryNameEn
      }
      

      }
      if(this.inle=='de'){
         if(e.categoryNameEn.indexOf(":") !== -1){
             let d =JSON.parse(e.categoryNameEn)
        a=d.de
         } else{
        a=e.categoryNameEn
      } 
         
      
      }
      return a

    },
    ccac(){
      console.log(123);
      
      this.searchKey=''
    },
    changeActive (e) {
      this.active = e
    },
    downMoBan () {
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      link.href = this.downUrl;
      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      link.setAttribute("download", `${this.$t('menu.PartsImportTemplate')}.xlsx`);
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
      //执行a标签
    },
    httpRequest (item) {
      console.log(item.file.name);
      // this.fileList[0].name = item.file.name
      var formData = new FormData()
      formData.append('file', item.file)
      formData.append('mcSeriesModelId',this.value)
      
      importFilea(formData).then(res => {
        // this.fileList[0].name = item.file.name
        console.log('success', res);

        if (res.data.code == 200) {
          this.$message.success('导入成功')
          this.daoruFlag=false
          this.aclist = res.data.data
          this.showInfo=false
          setTimeout(() => {
            // location.reload()
          }, 1000)

        } else {
          this.$message.error(res.data.msg)
        }
      }).catch((err) => {
        this.$message.error(res.data.msg)
      })
    },
    openDaoRuDialog () {
      if(this.value!==''){
        this.daoruFlag = true
      }else{
        this.$message.error('请选择车型')
      }
     
    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();
      const { data: res } = await listMcSeriesModels(param);
      this.cartypelist = res.data;
    },
    filterCarModels(m){
      if(m == '') return ''
      if(this.cartypelist.some(e=>e.id == m)){
        return this.iszh == 'zh' ? this.cartypelist.filter(e=>e.id == m)[0].seriesModel : this.cartypelist.filter(e=>e.id == m)[0].seriesModelEn
      } else {
        return m
      }
    },
    
    deleteCoparts(index,row){
      this.carInfo.coParts.splice(index,1)
    },
    sumMoney(){
      this.amount = 0
      this.carInfo.coParts.forEach(e=>{
        this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
      console.log(this.carInfo.coParts);
      
    },
    //车架号查询
    querySearch () {
      let params = 'searchValue=' + this.frameNum
      mcVehicleOfDealerLista(params).then(res=>{
        if(res.data.total !== 0){
          this.carInfo.co= {...this.carInfo.co,...res.data.rows[0]}
          this.carInfo.co.engineNo = this.carInfo.co.engineNumber
          this.carInfo.co.sellingTime = this.carInfo.co.salesDate
          this.carInfo.co.ownerName = this.carInfo.co.customerName
          this.carInfo.co.imageData = ''
          delete this.carInfo.co.status
          this.showInfo = false
        }else{
          this.showinfoMsg = this.$t('menu.Novehiclemodelinformation') 
        }
      })
    },
    
    //我的理赔单详情
    getMyCoDto (id) {
      getMyCoDto('coId=' + id).then(res => {
        this.carInfo = res.data.data
        this.fileList = JSON.parse(res.data.data.co.imageData)
      })
    },
    NumFormat2(value) {
      if (!value) return '0.00';
      // 将数值截取，保留两位小数
      value = Number(value).toFixed(2);
      // 获取整数部分
      const intPart = Math.trunc(value);
      // 整数部分处理，增加,
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      let floatPart = '.00';
      // 将数值截取为小数部分和整数部分
      const valueArray = Number(value)
          .toString()
          .split('.');
      if (valueArray.length === 2) {
          // 有小数部分
          floatPart = valueArray[1].toString(); // 取得小数部分
          return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    },
    //提交
    submit () {
      this.carInfo.coParts.forEach(e=>{
        e.partId = e.id
        e.quantity = e.minPurchaseQuantity
        e.amount=Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
      let data= {
        co:{
          applicationTime:this.carInfo.co.applicationTime != '' ? this.carInfo.co.applicationTime  +' 00:00:00' : '',
          causeAnalysis:this.carInfo.co.causeAnalysis,
          claimType:this.carInfo.co.claimType,
          engineNo:this.carInfo.co.engineNo,
          faultDescription:this.carInfo.co.faultDescription,
          imageData:this.carInfo.co.imageData,
          mileage:this.carInfo.co.mileage,
          repairPlan:this.carInfo.co.repairPlan,
          vin:this.carInfo.co.chassisNumber,
          faultType:this.carInfo.co.faultType,
          // applyDealerAreaId:this.carInfo.co.applyDealerAreaId,
          applyingDealerAreaId:this.carInfo.co.applyingDealerAreaId,
         
        },
        coParts:this.carInfo.coParts,
        vinlist:this.aclist
      }
      submitCoDto(data).then(res=>{
        console.log(111111111,res);
        
        if(res.data.code == 200){
          this.centerDialogVisible = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //修改 tijiao
    updateMyCo(){
      // updateMyCo().then(res=>{

      // })
      // this.carInfo.co.applicationTime=this.carInfo.co.applicationTime != '' ? this.carInfo.co.applicationTime  +' 00:00:00' : '',
      this.carInfo.coParts.forEach(e=>{
        e.partId = e.id
      })
      submitCoDto(this.carInfo).then(res=>{
        if(res.data.code == 200){
          this.centerDialogVisible = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    modify(){
      this.type = 1
      this.carInfo.coParts.forEach((e,index)=>{
        if(e.quantity){
          e.minPurchaseQuantity = e.quantity
          this.$set(this.carInfo.coParts,index,e)
          if(this.currency == 'CNY'){
            e.purchasePriceCny = e.unitPrice
            this.$set(this.carInfo.coParts,index,e)
          } else if(this.currency == 'EUR'){
            e.purchasePriceEur = e.unitPrice
            this.$set(this.carInfo.coParts,index,e)
          } else {
            e.purchasePriceUsd = e.unitPrice
            this.$set(this.carInfo.coParts,index,e)
          }
        }
      })
    },
    // 继续申请
    continueToApply(){
      location.reload(); //刷新当前页面
    },
    // 查看订单
    viewOrders(){
      this.$router.push("/ClaimOrder");
    },
    //取消申请
    cancelMyCo () {
      let params = 'coId=' + this.$route.query.id + '&remarks='
      cancelMyCo(params).then(res => {
        console.log(res,'取消申请');
        if(res.data.code==200){
          this.$message({
          message: 'success',
          type: 'success'
        });
        this.$router.go(0)
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    //取消
    cancel(){
      this.$router.push('/ClaimOrder')
    },
    
    getpartList(){
      this.carInfo.coParts = [...this.carInfo.coParts,...this.selectpart]
      this.carInfo.coParts.forEach(e=>{
        this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
      this.dialogVisiblePart = false
    },
    
    //添加配件
    addParts () {
         this.searchKey=''
      this.pageQueryPartList()
      this.dialogVisiblePart = true
    },
    async  pageQueryPartList () {
      let param = new URLSearchParams();
      let mcSeriesModelId 
      if(this.carInfo.co.params){
        mcSeriesModelId = this.value
      } else {
        
        mcSeriesModelId = this.value
      }
      let searchKey =this.searchKey 
      const { data: res } = await pageQueryParta(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey
      );
      this.partList = res.data.list
    },
    handleSelectionChange(val) {
      this.selectpart = val
    },
    
    pageQuerySa () {
      pageQuerySa().then(res => {

      })
    },
    //表头添加红色必填符号*
    renderHeader (h, { column, $index }) {
      return h(
        'div',
        [
          h('span', { style: 'color:red' }, '* '),
          h('span', column.label)
        ]
      )
    },
    async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area/%20/', sessionStorage.getItem('userId'));
      this.gb = res.data
    },
    async gbquerytypea () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer/%20/', sessionStorage.getItem('userId'));
      this.jxc = res.data
    },
    bbca (e) {
      let a = ''
      let b = this.aeera
      b.forEach(z => {
        if (z.dictLabel == e) {
          a = z
        }
      })
      let bb = ''
      if (this.iszh == 'zh') {
        bb = a.dictLabel
      } else {
        bb = a.dictLabelEn
      }
      return bb
    },
    bbcaa (e) {
 
      
      let a = ''
      let b = this.gb
  
      b.forEach(z => {
        console.log(456456,z.dictCode,e);
        if (z.dictValue == e) {
          if (this.iszh == 'zh') {
        a = z.dictLabel
       
      } else {
        a = z.dictLabelEn
      }
        }
      })
    
     
      return a
    },
    async aeer () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(param, 'area');
      this.aeera = res.data
    },
    beforeAvatarUpload(file){
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isLt2M;
    },
    uploadFile (file) {
      let formdata = new FormData()
      formdata.append('file', file.file)
      formdata.append('category', file.file.type)
      upload(formdata).then(res => {
        if (res.data.code == '200') {
          this.$message.success('上传成功')
          let obj = {
            name:file.file.name,
            url:res.data.data
          }
          this.fileList.push(obj)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    handleRemove(file, fileList) {
      this.fileList.forEach((e,i)=>{
        if(e.name == file.file.name){
          this.fileList.splice(i,1)
        }
      })
    },
    handlePictureCardPreview (file) {
      // if(file.url){
      //   this.filedialogImageUrl = file.url;
      // } else {
      //   this.fileList.filter(e=>e.name == file.file.name)[0].url
      // }
    },
    
    checkStaus(e){
      if(e == 10){
        return '待业务接收'
      } else if (e ==20){
        return '审核中'
      } else if (e ==29){
        return '审核中'
      } else if (e ==30){
        return '审核中'
      } else if (e ==39){
        return '审核中'
      } else if (e ==40){
        return '审核中'
      } else if (e ==49){
        return '审核中'
      } else if (e ==50){
        return this.$t('menu.Approved')
      } else if (e ==59){
        return '已驳回'
      } else if (e ==60){
        return '已取消'
      } else {
        return e
      }
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_co_claim_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleList.push(i)
          })
        }
      })
      querytype( params, 't_co_fault_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleLista.push(i)
          })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.fullpage {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  .searchBox{
    display: flex;
    width: 100%;
    align-items: center;  
    :deep(.el-input){
      width: 400px;
      margin-right: 20px;
    }
  }

  .title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #dcdfe6;
    margin: 10px 0;
    font-size: 18px;

    .name {
      border-left: 3px solid #409eff;
      padding-left: 10px;
      height: 22px;
      line-height: 22px;
    }
  }

  .basicInformation {
    width: 100%;
    margin-top: 20px;

    .Info {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 10px;

      .infoItem {
        width: 30%;
        height: 70px;
        display: flex;
        flex-direction: column;

        .name {
        margin: 10px 0;
        color: #909399;
        }

        .infoData {}
      }
    }
  }

  .compensateInfo {
    width: 100%;
    margin-top: 20px;
    .beforeShowInfo{
      color: red;
      padding-left: 20px;
    }

    .infoItemOne {
      margin-top: 30px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 10px;

      .infoItemOneItem {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-bottom: 20px;
        .name {
          margin: 10px 0;
          color: #909399;
        }

        .inputBox {
          width: 70%;
        }
      }
    }

    .infoItemTwo {
      width: 100%;
      padding-left: 10px;
      padding-bottom: 20px;

      .name {
        margin: 10px 0;
        color: #909399;
      }
    }
  }
/deep/.el-upload-list__item{
  width: fit-content;
}
  .compensateDetail {
    width: 100%;
    margin-top: 20px;

    .title {
      .nameList {
        border-left: 3px solid #409eff;
        padding-left: 10px;
        height: 22px;
        line-height: 22px;
        display: flex;

        .nameItem {
          margin-right: 40px;
          cursor: pointer;
        }

        .acti {
          color: #409eff;
        }
      }
    }

    .detail {
      width: 100%;
      padding-bottom: 30px;

      :deep(.el-upload-list__item.is-success .el-upload-list__item-status-label){ 
        position: static;
      }
      :deep(.el-upload-list__item){
        display: flex;
        align-items: center;
      }
      :deep(.el-icon-close){
        position: static;
      }

      .typeTitle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
      }

      .uploadFiles {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        width: 300px;

        .bluecolor {
          color: #409eff;
        }

        .redcolor {
          color: red;
        }
      }
    }
  }

  .subBox {
    height: 60px;
    //border-top: 1px solid #dcdfe6;
    //border-bottom: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .partBox {
    border-top: 1px solid #dcdfe6;
    padding: 20px;

    .searchBox {
      margin-bottom: 20px;

      /deep/.el-input {
        width: 50%;
      }

      /deep/.el-button {
        margin-left: 20px;
      }
    }

    .buttBox {
      width: 100%;
      text-align: center;
      padding: 30px;
    }

  }
  .img{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  :deep(.el-textarea__inner){
    font-family: inherit;
  }
}

/deep/.el-dialog__body {
  padding: 0 !important;
}
</style>